<template lang="pug">
  b-modal#addPromo(
    ref="addPromo"
    :title="$t('ui.combine.add_promo')"
    centered
    no-fade
    no-close-on-backdrop
    size="lg"
    :busy="loading"
    @ok="done"
    @show="reset"
    @shown="shown"
  )
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-card
        div.row
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.promotion_id')").mb-0
              DebounceInput(
                size="sm"
                ref="promotion_id"
                required
                type="text"
                :dirty="$v.promotion_id.$dirty"
                :error="$v.promotion_id.$error"
                v-model.trim.lazy="$v.promotion_id.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.promotion_id" :name="$t('ui.promotion_id')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.promotion_name')").mb-0
              DebounceInput(
                size="sm"
                ref="promotion_name"
                required
                type="text"
                :dirty="$v.promotion_name.$dirty"
                :error="$v.promotion_name.$error"
                v-model.trim.lazy="$v.promotion_name.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.promotion_name" :name="$t('ui.promotion_name')")
        div.row
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.claim_type')").mb-0
              ClaimTypeLookup(
                ref="claim_type"
                size="sm"
                required
                type="array"
                :dirty="$v.claim_type.$dirty"
                :error="$v.claim_type.$error"
                v-model.trim.lazy="$v.claim_type.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.claim_type" :name="$t('ui.claim_type')")
          div.col-sm-12.col-md-3.col-lg-3(v-if="!['ALL DAY','NEWBIE','ONCE','DAILY FIRST DEPOSIT'].includes(claim_type)")
            b-form-group(:label="$t('ui.claim_limit')").mb-0
              DebounceInput(
                size="sm"
                ref="claim_limit"
                required
                type="text"
                :dirty="$v.claim_limit.$dirty"
                :error="$v.claim_limit.$error"
                v-model.trim.lazy="$v.claim_limit.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.claim_limit" :name="$t('ui.claim_limit')")
          div.col-sm-12.col-md-3.col-lg-3(v-if="!['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(claim_type)")
            b-form-group(:label="$t('ui.bonus_rate_percent')").mb-0
              DebounceInput(
                size="sm"
                ref="bonus_rate"
                required
                type="text"
                :dirty="$v.bonus_rate.$dirty"
                :error="$v.bonus_rate.$error"
                v-model.trim.lazy="$v.bonus_rate.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.bonus_rate" :name="$t('ui.bonus_rate_percent')")
        .row(v-if="['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(claim_type) && claim_limit > 0 && claim_limit <= 10")
          div.col-sm-12.col-md-12.col-lg-12
            b-form-group(:label="$tc('ui.bonus_rate', 2)")
              div.row.animated.fadeIn
                div.col
                  table.tablex(style="width: auto;")
                    thead
                      tr
                        th.text-center(v-for="x in Number(this.claim_limit)")
                          span {{ $t('ui.bonus_rate_' + x) }}
                    tbody
                      tr
                        td(v-for="x in Number(this.claim_limit)")
                          div.d-flex.justify-content-center.align-items-center
                            DebounceInput.text-center.w-10(
                              size="sm"
                              :ref="'bonus_rate_' + x"
                              required
                              type="text"
                              :dirty="$v.formBonusRate['bonus_rate_' + x].$dirty"
                              :error="$v.formBonusRate['bonus_rate_' + x].$error"
                              v-model="formBonusRate['bonus_rate_' + x]"
                              :disabled="loading"
                            )
                          //- ValidateResult(:value="$v.formBonusRate['bonus_rate_' + x]" :name="$t('ui.bonus_rate_percent')")
        .row
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.deposit_amount')").mb-0
              DebounceInput(
                size="sm"
                ref="min_deposit"
                required
                type="text"
                :dirty="$v.min_deposit.$dirty"
                :error="$v.min_deposit.$error"
                v-model.trim.lazy="$v.min_deposit.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.min_deposit" :name="$t('ui.deposit_amount')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.max_bonus')").mb-0
              DebounceInput(
                size="sm"
                ref="max_bonus"
                required
                type="text"
                :dirty="$v.max_bonus.$dirty"
                :error="$v.max_bonus.$error"
                v-model.trim.lazy="$v.max_bonus.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.max_bonus" :name="$t('ui.max_bonus')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.rollover')").mb-0
              DebounceInput(
                size="sm"
                ref="rollover"
                type="text"
                :dirty="$v.rollover.$dirty"
                :error="$v.rollover.$error"
                v-model.trim.lazy="$v.rollover.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.rollover" :name="$t('ui.rollover')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.criteria')").mb-0
              VipCriteriaList(
                ref="criteria"
                size="sm"
                required
                type="array"
                :dirty="$v.criteria.$dirty"
                :error="$v.criteria.$error"
                v-model.trim.lazy="$v.criteria.$model"
                :disabled="loading"
                :hideOpt="hideOpt"
              )
              ValidateResult(:value="$v.criteria" :name="$t('ui.criteria')")
        div.row
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.withhold_bonus')").mb-2
              div.d-flex
                label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                  input.switch-input(
                    type="checkbox"
                    required
                    :dirty="$v.withhold_bonus.$dirty"
                    :error="$v.withhold_bonus.$error"
                    v-model.trim.lazy="$v.withhold_bonus.$model"
                    :disabled="loading"
                  )
                  span.switch-slider(:data-checked='on' :data-unchecked='off')
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.withhold_amount')").mb-0
              DebounceInput(
                size="sm"
                ref="withhold_amount"
                required
                type="text"
                :dirty="$v.withhold_amount.$dirty"
                :error="$v.withhold_amount.$error"
                v-model.trim.lazy="$v.withhold_amount.$model"
                :disabled="loading || withhold_bonus"
              )
              ValidateResult(:value="$v.withhold_amount" :name="$t('ui.withhold_amount')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.max_withdraw_amount')").mb-0
              DebounceInput(
                size="sm"
                ref="max_withdraw_amount"
                required
                type="text"
                :dirty="$v.max_withdraw_amount.$dirty"
                :error="$v.max_withdraw_amount.$error"
                v-model.trim.lazy="$v.max_withdraw_amount.$model"
                :disabled="loading || max_withdraw_multiple > 0"
              )
              ValidateResult(:value="$v.max_withdraw_amount" :name="$t('ui.max_withdraw_amount')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.max_withdraw_multiple')").mb-0
              DebounceInput(
                size="sm"
                ref="max_withdraw_multiple"
                required
                type="text"
                :dirty="$v.max_withdraw_multiple.$dirty"
                :error="$v.max_withdraw_multiple.$error"
                v-model.trim.lazy="$v.max_withdraw_multiple.$model"
                :disabled="loading || max_withdraw_amount > 0"
              )
              ValidateResult(:value="$v.max_withdraw_multiple" :name="$t('ui.max_withdraw_multiple')")
        .row
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.start_date')").mb-0
              b-input-group(size="sm")
                date-picker(
                  ref="start_date"
                  :config="localeDate"
                  :dirty="$v.start_date.$dirty"
                  :error="$v.start_date.$error"
                  v-model.trim.lazy="$v.start_date.$model"
                  :disabled="loading"
                )
              ValidateResult(:value="$v.start_date" :name="$t('ui.start_date')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.start_time')").mb-0
              b-input-group(size="sm")
                date-picker(
                  ref="start_time"
                  :config="localeTime"
                  :dirty="$v.start_time.$dirty"
                  :error="$v.start_time.$error"
                  v-model.trim.lazy="$v.start_time.$model"
                  :disabled="loading"
                )
              ValidateResult(:value="$v.start_time" :name="$t('ui.start_time')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.end_date')").mb-0
              b-input-group(size="sm")
                date-picker(
                  ref="end_date"
                  :config="localeDate"
                  :dirty="$v.end_date.$dirty"
                  :error="$v.end_date.$error"
                  v-model.trim.lazy="$v.end_date.$model"
                  :disabled="loading"
                )
              ValidateResult(:value="$v.end_date" :name="$t('ui.end_date')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.end_time')").mb-0
              b-input-group(size="sm")
                date-picker(
                  ref="end_time"
                  :config="localeTime"
                  :dirty="$v.end_time.$dirty"
                  :error="$v.end_time.$error"
                  v-model.trim.lazy="$v.end_time.$model"
                  :disabled="loading"
                )
              ValidateResult(:value="$v.end_time" :name="$t('ui.end_time')")
        div.row
          div.col-sm-12.col-md-12.col-lg-12
            b-form-group(:label="$tc('ui.day', 2)")
              div.row.animated.fadeIn
                div.col
                  table.tablex(style="width: 100%;")
                    thead
                      tr
                        th.text-center
                          span {{ $t('ui.monday') }}
                        th.text-center
                          span {{ $t('ui.tuesday') }}
                        th.text-center
                          span {{ $t('ui.wednesday') }}
                        th.text-center
                          span {{ $t('ui.thursday') }}
                        th.text-center
                          span {{ $t('ui.friday') }}
                        th.text-center
                          span {{ $t('ui.saturday') }}
                        th.text-center
                          span {{ $t('ui.sunday') }}
                    tbody
                      tr
                        td
                          div.d-flex.justify-content-center.align-items-center
                            label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                              input.switch-input(
                                type="checkbox"
                                required
                                :dirty="$v.monday.$dirty"
                                :error="$v.monday.$error"
                                v-model.trim.lazy="$v.monday.$model"
                                :disabled="loading"
                              )
                              span.switch-slider(:data-checked='on' :data-unchecked='off')
                          ValidateResult(:value="$v.monday" :name="$t('ui.monday')")
                        td
                          div.d-flex.justify-content-center.align-items-center
                            label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                              input.switch-input(
                                type="checkbox"
                                required
                                :dirty="$v.tuesday.$dirty"
                                :error="$v.tuesday.$error"
                                v-model.trim.lazy="$v.tuesday.$model"
                                :disabled="loading"
                              )
                              span.switch-slider(:data-checked='on' :data-unchecked='off')
                          ValidateResult(:value="$v.tuesday" :name="$t('ui.tuesday')")
                        td
                          div.d-flex.justify-content-center.align-items-center
                            label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                              input.switch-input(
                                type="checkbox"
                                required
                                :dirty="$v.wednesday.$dirty"
                                :error="$v.wednesday.$error"
                                v-model.trim.lazy="$v.wednesday.$model"
                                :disabled="loading"
                              )
                              span.switch-slider(:data-checked='on' :data-unchecked='off')
                          ValidateResult(:value="$v.wednesday" :name="$t('ui.wednesday')")
                        td
                          div.d-flex.justify-content-center.align-items-center
                            label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                              input.switch-input(
                                type="checkbox"
                                required
                                :dirty="$v.thursday.$dirty"
                                :error="$v.thursday.$error"
                                v-model.trim.lazy="$v.thursday.$model"
                                :disabled="loading"
                              )
                              span.switch-slider(:data-checked='on' :data-unchecked='off')
                          ValidateResult(:value="$v.thursday" :name="$t('ui.thursday')")
                        td
                          div.d-flex.justify-content-center.align-items-center
                            label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                              input.switch-input(
                                type="checkbox"
                                required
                                :dirty="$v.friday.$dirty"
                                :error="$v.friday.$error"
                                v-model.trim.lazy="$v.friday.$model"
                                :disabled="loading"
                              )
                              span.switch-slider(:data-checked='on' :data-unchecked='off')
                          ValidateResult(:value="$v.friday" :name="$t('ui.friday')")
                        td
                          div.d-flex.justify-content-center.align-items-center
                            label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                              input.switch-input(
                                type="checkbox"
                                required
                                :dirty="$v.saturday.$dirty"
                                :error="$v.saturday.$error"
                                v-model.trim.lazy="$v.saturday.$model"
                                :disabled="loading"
                              )
                              span.switch-slider(:data-checked='on' :data-unchecked='off')
                          ValidateResult(:value="$v.saturday" :name="$t('ui.saturday')")
                        td
                          div.d-flex.justify-content-center.align-items-center
                            label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                              input.switch-input(
                                type="checkbox"
                                required
                                :dirty="$v.sunday.$dirty"
                                :error="$v.sunday.$error"
                                v-model.trim.lazy="$v.sunday.$model"
                                :disabled="loading"
                              )
                              span.switch-slider(:data-checked='on' :data-unchecked='off')
                          ValidateResult(:value="$v.sunday" :name="$t('ui.sunday')")
        .row
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.promotion_group')").mb-0
              PromotionGroupLookup(
                ref="promotion_group"
                size="sm"
                required
                type="array"
                :dirty="$v.promotion_group.$dirty"
                :error="$v.promotion_group.$error"
                v-model.trim.lazy="$v.promotion_group.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.promotion_group" :name="$t('ui.promotion_group')")
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.promotion_type')").mb-0
              PromotionType(
                ref="promotion_type"
                size="sm"
                required
                type="array"
                :dirty="$v.promotion_type.$dirty"
                :error="$v.promotion_type.$error"
                v-model.trim.lazy="$v.promotion_type.$model"
                :disabled="loading"
              )
              ValidateResult(:value="$v.promotion_type" :name="$t('ui.promotion_type')")
        .row(v-if="['DEPOSIT'].includes(promotion_type)")
          div.col-sm-12.col-md-12.col-lg-12
            b-form-group(:label="$t('ui.vip')").mb-0
              table
                tr
                  th
                    b-form-checkbox(v-model="allSelectedVIP" @change="selectAllVIP")
                      span.font-weight-bold {{ allSelectedVIP  ? $t('ui.unselect_all') : $t('ui.select_all') }}
                tr(v-for="(row, rowIndex) in rowsVIPList" :key="rowIndex")
                  td(v-for='(p, itemIndex) in row' :key="itemIndex")
                    b-form-checkbox(v-model="vip_list" :value='p.value') {{ p.text }}
              ValidateResult(:value="$v.vip_list" :name="$t('ui.vip')")
        .row(v-if="['CUSTOM'].includes(promotion_type)")
          div.col-sm-12.col-md-12.col-lg-12
            b-form-group(:label="$t('ui.member_list')")
              b-form-textarea.col-12(
                ref="member_list"
                size="sm"
                required
                :dirty="$v.member_list.$dirty"
                :error="$v.member_list.$error"
                v-model.trim.lazy="$v.member_list.$model"
                rows="10"
                max-rows="10"
                trim=true
                :disabled="loading"
                @paste="handlePaste"
              )
            ValidateResult(:value="$v.member_list" :name="$t('ui.member_list')")
      b-card
        .row
          div.col-sm-12.col-md-3.col-lg-3
            b-form-group(:label="$t('ui.payment_option')" style="overflow: hidden scroll; height: 15vh;").mb-0
              table
                tr
                  th
                    b-form-checkbox(v-model="allSelectedPO" @change="selectAllPO")
                  th
                    span.font-weight-bold {{ allSelectedPO  ? $t('ui.unselect_all') : $t('ui.select_all') }}
                tr(v-for='p in paymentOptionList')
                  td
                    b-form-checkbox(v-model="payment_option_list" :value='p.value')
                  td {{ p.text }}
            ValidateResult(:value="$v.payment_option_list" :name="$t('ui.payment_option')")
          div.col-sm-12.col-md-9.col-lg-9
            b-form-group(:label="$t('ui.payment_gateway')").mb-0
              //- BankProviderLookup(
              //-   ref="payment_gateway_list"
              //-   size="sm"
              //-   required
              //-   type="array"
              //-   :dirty="$v.payment_gateway_list.$dirty"
              //-   :error="$v.payment_gateway_list.$error"
              //-   v-model.trim.lazy="$v.payment_gateway_list.$model"
              //-   :disabled="loading"
              //- )
              table
                tr
                  th
                    b-form-checkbox(v-model="allSelectedPG" @change="selectAllPG")
                      span.font-weight-bold {{ allSelectedPG  ? $t('ui.unselect_all') : $t('ui.select_all') }}
                tr(v-for="(row, rowIndex) in rowsPGList" :key="rowIndex")
                  td(v-for='(p, itemIndex) in row' :key="itemIndex")
                    b-form-checkbox(v-model="payment_gateway_list" :value='p.value') {{ p.value }}
              ValidateResult(:value="$v.payment_gateway_list" :name="$t('ui.payment_gateway_list')")
        div.row
          div.col-sm-12.col-md-12.col-lg-12
            div.row
              div.col-sm-12.col-md-12.col-lg-12
                b-form-group(:label="$t('ui.provider_list')" style="overflow: hidden scroll; height: 20vh;").mb-0
                  table
                    tr
                      th
                        b-form-checkbox(v-model="allSelected" @change="selectAll")
                          span.font-weight-bold {{ allSelected  ? $t('ui.unselect_all') : $t('ui.select_all') }}
                    tr(v-for="(row, rowIndex) in rowsPList" :key="rowIndex")
                      td(v-for='(p, itemIndex) in row' :key="itemIndex")
                        b-form-checkbox(v-model="provider_list" :value='p.value') {{ p.text }}
                ValidateResult(:value="$v.provider_list" :name="$t('ui.provider_list')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import VipCriteriaList from "@/library/VipCriteriaList";
import ClaimTypeLookup from "@/library/ClaimTypeLookup";
import PromotionType from "@/library/PromotionType";
import PromotionGroupLookup from "@/library/PromotionGroupLookup";
import BankProviderLookup from "@/library/BankProviderLookup";
import VipLookup from "@/library/VipLookup";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const atLeastOneProvider = (value) => value.length > 0;
const atLeastOnePaymentOption = (value) => value.length > 0;
const atLeastOneOption = (value) => value.length > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    VipCriteriaList,
    ClaimTypeLookup,
    PromotionType,
    PromotionGroupLookup,
    BankProviderLookup,
    VipLookup
  },
  props: {
  },
  data() {
    return {
      promotion_id: "",
      promotion_name: "",
      claim_type: "",
      min_deposit: "",
      bonus_rate: "",
      max_bonus: 0,
      rollover: "",
      criteria: "",
      withhold_bonus: false,
      withhold_amount: 0,
      max_withdraw_amount: 0,
      start_date: "",
      end_date: "",
      start_time: "",
      end_time: "",
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: true,
      sunday: true,
      claim_limit: 0,
      max_withdraw_multiple: 0,
      provider_list: [],
      providerList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      localeDate: {
        format: "YYYY-MM-DD",
        useCurrent: true
      },
      localeTime: {
        format: "HH:mm:ss",
        useCurrent: true
      },
      hideOpt: ['DEPOSIT'],
      allSelected: false,

      payment_option_list: [],
      paymentOptionList: [],
      allSelectedPO: false,
      promotion_type: "",
      promotion_group: "",
      allSelectedPG: false,
      payment_gateway_list: [],
      paymentGatewayList: [],
      allSelectedVIP: false,
      vip_list: [],
      vipList: [],
      member_list: "",
      formBonusRate: {}
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    rowsPGList() {
      const rows = [];
      for (let i = 0; i < this.paymentGatewayList.length; i += 5) {
        rows.push(this.paymentGatewayList.slice(i, i + 5));
      }
      return rows;
    },
    rowsPList() {
      const rows = [];
      for (let i = 0; i < this.providerList.length; i += 3) {
        rows.push(this.providerList.slice(i, i + 3));
      }
      return rows;
    },
    rowsVIPList() {
      const rows = [];
      for (let i = 0; i < this.vipList.length; i += 8) {
        rows.push(this.vipList.slice(i, i + 8));
      }
      return rows;
    },
  },
  validations() {
    const formBonusRateValidations = {};
    for (let i = 1; i <= Number(this.claim_limit); i++) {
      // formBonusRateValidations[`bonus_rate_${i}`] = { required,decimal };
      formBonusRateValidations[`bonus_rate_${i}`] = { 
        required : requiredIf(function () {
          return ['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(this.claim_type);
        }),
        decimal
      };
    }
    return {
      formBonusRate: formBonusRateValidations,
      promotion_id: {
        required,
        alphaNum,
        minLength: minLength(6),
        maxLength: maxLength(20)
      },
      promotion_name: {
        required,
        // minLength: minLength(6),
        maxLength: maxLength(100)
      },
      claim_type: {
        required
      },
      min_deposit: {
        required,
        decimal,
        // minValue(value) {
        //   return minValue(this.getMinDeposit)(value)
        // }
      },
      bonus_rate: {
        required,
        decimal
      },
      max_bonus: {
        required,
        decimal
      },
      rollover: {
        required,
        decimal,
        minValue: minValue(1)
      },
      criteria: {
        required
      },
      promotion_type: {
        required
      },
      withhold_bonus: {
        required
      },
      withhold_amount: {
        required,
        decimal
      },
      max_withdraw_amount: {
        required,
        decimal
      },
      start_date: {
        required
      },
      end_date: {
        required
      },
      start_time: {
        required
      },
      end_time: {
        required
      },
      monday: {
        required
      },
      tuesday: {
        required
      },
      wednesday: {
        required
      },
      thursday: {
        required
      },
      friday: {
        required
      },
      saturday: {
        required
      },
      sunday: {
        required
      },
      claim_limit: {
        integer,
        maxValue(value) {
          if (['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(this.claim_type)) {
            return maxValue(10)(value)
          } else {
            return true
          }
        },
        required: requiredIf(function () {
          return ['ALL DAY','NEWBIE','ONCE'].includes(this.claim_type);
        })
      },
      max_withdraw_multiple: {
        required,
        integer
      },
      provider_list: {
        atLeastOneProvider,
        minLength: minLength(1)
      },
      payment_option_list: {
        atLeastOnePaymentOption,
        minLength: minLength(1)
      },
      payment_gateway_list: {
        atLeastOneOption,
        minLength: minLength(1)
      },
      vip_list: {
        minLength(value) {
          if(['DEPOSIT'].includes(this.promotion_type)) {
            return minLength(1)(value)
          } else {
            return minLength(0)(value)
          }
        },
        required: requiredIf(function () {
          return ['DEPOSIT'].includes(this.promotion_type);
        })
      },
      promotion_type: {
        required
      },
      promotion_group: {
        required
      },
      member_list: {
        required: requiredIf(function () {
          return ['CUSTOM'].includes(this.promotion_type);
        })
      },
    }
  },
  watch : {
    provider_list(newValue, oldValue) {
      if (newValue.length === 0)
        this.allSelected = false;
      else if (newValue.length === this.providerList.length)
        this.allSelected = true;
      else
        this.allSelected = false;
    },
    payment_option_list(newValue, oldValue) {
      if (newValue.length === 0)
        this.allSelectedPO = false;
      else if (newValue.length === this.paymentOptionList.length)
        this.allSelectedPO = true;
      else
        this.allSelectedPO = false;
    },
    payment_gateway_list(newValue, oldValue) {
      if (newValue.length === 0)
        this.allSelectedPG = false;
      else if (newValue.length === this.paymentGatewayList.length)
        this.allSelectedPG = true;
      else
        this.allSelectedPG = false;
    },
    vip_list(newValue, oldValue) {
      if (newValue.length === 0)
        this.allSelectedVIP = false;
      else if (newValue.length === this.vipList.length)
        this.allSelectedVIP = true;
      else
        this.allSelectedVIP = false;
    },
    withhold_bonus(newVal) {
      if(newVal)
        this.withhold_amount = 0
    },
    claim_type(newVal) {
      if(['ALL DAY','NEWBIE','ONCE'].includes(newVal))
        this.claim_limit = 0

      if(['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(newVal))
        this.bonus_rate = 0
    },
    promotion_type(newVal) {
      if(['CUSTOM'].includes(newVal))
        this.vip_list = []

      if(['DEPOSIT'].includes(newVal))
        this.member_list = ""

      if(['ALL'].includes(newVal)) {
        this.member_list = ""
        this.vip_list = []
      }
    }
  },
  methods: {
    handlePaste(event) {
      event.preventDefault(); // Prevent the default paste action

      // Get the pasted data from the clipboard
      let pastedData = event.clipboardData.getData('Text');

      // Remove newline characters from the pasted data
      pastedData = pastedData.replace(/\n/g, ' ');

      // Split the pasted data into an array by whitespace characters
      let dataArray = pastedData.split(' ');

      // Remove the first row if it is "ID"
      if (dataArray[0].trim() === 'ID') {
        dataArray.shift();
      }

      // Filter out any empty strings in the array
      dataArray = dataArray.map(item => item.trim()).filter(item => item !== '');

      // Join the array into a comma-separated string
      const commaSeparatedData = dataArray.join(', ');

      // Set the text area content to the comma-separated string
      this.member_list = commaSeparatedData;
    },
    selectAll: function() {
      this.provider_list = [];

      let list = this.providerList;

      if (!this.allSelected) {
        for(var i = 0; i < list.length; i++) {
          this.provider_list.push(list[i].value);
        }
      }
    },
    selectAllPO: function() {
      this.payment_option_list = [];

      let list = this.paymentOptionList;

      if (!this.allSelectedPO) {
        for(var i = 0; i < list.length; i++) {
          this.payment_option_list.push(list[i].value);
        }
      }
    },
    selectAllPG: function() {
      this.payment_gateway_list = [];

      let list = this.paymentGatewayList;

      if (!this.allSelectedPG) {
        for(var i = 0; i < list.length; i++) {
          this.payment_gateway_list.push(list[i].value);
        }
      }
    },
    selectAllVIP: function() {
      this.vip_list = [];

      let list = this.vipList;

      if (!this.allSelectedVIP) {
        for(var i = 0; i < list.length; i++) {
          this.vip_list.push(list[i].value);
        }
      }
    },
    removeDuplicate(arr) {
      let s = new Set(arr);
      let it = s.values();
      return Array.from(it);
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.withhold_bonus && parseFloat(this.withhold_amount) > 0) {
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.withtholdBonusAndAmountGreaterThanZero"), "error");
          return;
        }

        if (parseFloat(this.max_withdraw_amount) > 0 && parseFloat(this.max_withdraw_multiple) > 0) {
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.maxWithdrawMultipleAndAmountGreaterThanZero"), "error");
          return;
        }

        let url = config.promotionAddUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          promotion_id: this.promotion_id,
          promotion_name: this.promotion_name,
          claim_type: this.claim_type,
          min_deposit: this.min_deposit,
          bonus_rate: this.bonus_rate,
          max_bonus: this.max_bonus,
          rollover: this.rollover,
          criteria: this.criteria,
          withhold_bonus: this.withhold_bonus,
          withhold_amount: this.withhold_amount,
          max_withdraw_amount: this.max_withdraw_amount,
          start_date: this.start_date,
          end_date: this.end_date,
          start_time: this.start_time,
          end_time: this.end_time,
          monday: this.monday,
          tuesday: this.tuesday,
          wednesday: this.wednesday,
          thursday: this.thursday,
          friday: this.friday,
          saturday: this.saturday,
          sunday: this.sunday,
          claim_limit: this.claim_limit,
          max_withdraw_multiple: this.max_withdraw_multiple,
          promotion_type: this.promotion_type,
          promotion_group_id: this.promotion_group,
          member_list: this.member_list,
          bonus_rate_1: this.formBonusRate['bonus_rate_1'],
          bonus_rate_2: this.formBonusRate['bonus_rate_2'],
          bonus_rate_3: this.formBonusRate['bonus_rate_3'],
          bonus_rate_4: this.formBonusRate['bonus_rate_4'],
          bonus_rate_5: this.formBonusRate['bonus_rate_5'],
          bonus_rate_6: this.formBonusRate['bonus_rate_6'],
          bonus_rate_7: this.formBonusRate['bonus_rate_7'],
          bonus_rate_8: this.formBonusRate['bonus_rate_8'],
          bonus_rate_9: this.formBonusRate['bonus_rate_9'],
          bonus_rate_10: this.formBonusRate['bonus_rate_10'],
          audit_by: this.$store.getters.loginId
        };

        if (this.provider_list.length != this.providerList.length)
          json.provider_list = this.removeDuplicate(this.provider_list.sort()).toString();

        if (this.payment_option_list.length != this.paymentOptionList.length)
          json.payment_option_list = this.removeDuplicate(this.payment_option_list.sort()).toString();

        if (this.payment_gateway_list.length != this.paymentGatewayList.length)
          json.payment_gateway_list = this.removeDuplicate(this.payment_gateway_list.sort()).toString();

        if (this.vip_list.length != this.vipList.length)
          json.vip_list = this.removeDuplicate(this.vip_list.sort()).toString();

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.addPromo.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_promo", this.feedback.status);
                  this.$refs.addPromo.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    getProviderList: function() {
      // this.selectedFunctions = [];
      let url = config.providerMaintenanceListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // this.providerList = response.data.dt;
                // this.getPList();

                let list = response.data.dt;
                if(list.length > 0){
                  let result = [];
                  for(var i = 0; i < list.length; i++) {
                    result.push({value: list[i].provider_code.toUpperCase(), text: list[i].provider_name, checked: false});
                  }
                  this.providerList = result;
                } else {
                  this.providerList = [];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getPaymentOptionList: function() {
      // this.selectedFunctions = [];
      let url = config.paymentOptionListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // this.paymentOptionList = response.data.dt;
                // this.getPOList();
                let list = response.data.dt;
                if(list.length > 0){
                  let result = [];
                  // result.push({value: "all", text: this.$t("ui.all")});
                  for(var i = 0; i < list.length; i++) {
                    result.push({value: list[i].payment_mode.toUpperCase(), text: list[i].payment_desc, checked: false});
                  }
                  this.paymentOptionList = result;
                } else {
                  this.paymentOptionList = [];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getBankProviderList: function() {
      let url = config.bankProviderListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                let list = response.data.dt;
                if(list.length > 0){
                  let result = [];
                  for(var i = 0; i < list.length; i++) {
                    result.push({value: list[i].provider_group.toUpperCase(), text: list[i].provider_group.toUpperCase(), checked: false});
                  }
                  this.paymentGatewayList = result;
                } else {
                  this.paymentGatewayList = [];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getVIPList: function() {
      let url = config.vipListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                let list = response.data.dt;
                if(list.length > 0){
                  let result = [];
                  for(var i = 0; i < list.length; i++) {
                    result.push({value: list[i].vip_id, text: list[i].vip_name.toUpperCase(), checked: false});
                  }
                  this.vipList = result;
                } else {
                  this.vipList = [];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.promotion_id = "";
      this.promotion_name = "";
      this.claim_type = "";
      this.min_deposit = "";
      this.bonus_rate = "";
      this.max_bonus = 0;
      this.rollover = "";
      this.criteria = "";
      this.withhold_bonus = false;
      this.withhold_amount = 0;
      this.max_withdraw_amount = 0;
      this.start_date = this.$moment(new Date).format('YYYY-MM-DD');
      this.end_date = this.$moment(new Date).format('YYYY-MM-DD');
      this.start_time = "00:00:00";
      this.end_time = "23:59:59";
      this.monday = true;
      this.tuesday = true;
      this.wednesday = true;
      this.thursday = true;
      this.friday = true;
      this.saturday = true;
      this.sunday = true;
      this.claim_limit = 0;
      this.max_withdraw_multiple = 0;
      this.provider_list = [];
      this.payment_option_list = [];
      this.payment_gateway_list = [];
      this.promotion_type = "";
      this.promotion_group = "";
      this.vip_list = [];
      this.member_list = "";
      this.formBonusRate = {};
      this.providerList = [];
      this.paymentGatewayList = [];
      this.getProviderList();
      this.getPaymentOptionList();
      this.getBankProviderList();
      this.getVIPList();
      this.$refs.promotion_id.$el.focus();
    }
  }
};
</script>
